import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Box, Button, EmptyState } from '@node-space/ui-components'
import { Lottie } from 'components/Animations/ThemeLottie'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { PathNames } from 'constants/General'
import { RewardsProduct } from 'types/rewards'
import { ActionIds } from 'types/types'
import { formatAPY } from '../utils'
import { RewardCompoundedCalculator } from './RewardCompoundedCalculator'

interface RewardsNoWalletsProps {
  rewardsProducts: RewardsProduct[]
}

export const RewardsNoWallets = ({ rewardsProducts }: RewardsNoWalletsProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleAddWallet = () => {
    navigate(`${PathNames.WALLETS}?action=${ActionIds.WALLET_CREATE}`)
  }

  const maxRewardsAPY = rewardsProducts.reduce((max, product) => {
    return Math.max(max, product?.earningRate)
  }, 0)
  const rewardsProductCurrencies =
    rewardsProducts.map(product => product?.currency)?.filter(Boolean) ?? []

  return (
    <Box flexCol gap={16} className="lg:grid xl:grid-cols-[1fr_1fr] lg:items-start">
      <EmptyState
        testId="rewards-assets-no-wallets-empty-state"
        LottiePlayer={<Lottie src="welcome" />}
        title={t('rewards.noWalletsState.title', {
          currencies: [...rewardsProductCurrencies].join(`${t('and')} `),
          maxAPY: formatAPY(maxRewardsAPY),
        })}
        description={
          <>
            {t('rewards.noWalletsState.description', {
              currencies: rewardsProductCurrencies.join(', '),
            })}
            <ExternalLink href={process.env.REWARDS_HOW_IT_WORKS_URL} target="_blank">
              {t('rewards.descriptionLink')}
            </ExternalLink>
          </>
        }
        PrimaryButton={
          <Button onClick={handleAddWallet}>{t('rewards.noWalletsState.addWallet')}</Button>
        }
      />

      <RewardCompoundedCalculator />
    </Box>
  )
}
